import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { showAlert } from 'utility/SweetAlert'

const InteractorMasterBankView = () => {
  const bankView = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/master-bank/view', payload, (response) => {
      if (response.code === 7200) {
        callback(response.data)
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
          back: true,
        })
      }
      loading(false)
    })
  }, [])
  return { bankView }
}

export default InteractorMasterBankView
